import { Link } from "react-router-dom";

export default function SGBottomCTA() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/177d290e27b0a567d5963888f69ce066.jpg"
          alt="Calm interiors"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#FAF7F0]/82" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-8 md:px-16 text-center">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-6"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          From the Journal
        </p>
        <h2
          className="text-[#2C2825] text-4xl md:text-5xl mb-5"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          See these ideas in<br /><em>real spaces</em>
        </h2>
        <p
          className="text-[#6B5E53] text-sm leading-relaxed mb-12 max-w-sm mx-auto"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          Browse living rooms and cozy corners that bring the style guide to life.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/living-room"
            className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Explore Living Rooms
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
          <Link
            to="/cozy-corners"
            className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Explore Cozy Corners
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
